import React, { useEffect, useState } from "react";
import { useRef } from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import axios from "../../../../lib/axios";
import { Slide, toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate, useLocation } from "react-router-dom";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import checkAndLock from "../../../../GlobalFunction/checkAndLock";
import UnLock from "../../../../GlobalFunction/UnLock";
import axiosInstance from "../../../../lib/axios";
import { formatDeleteErrorMessage } from "../../../../GlobalFunction/ErrorMessageHelper";
import { Checkbox, FormControlLabel, FormGroup, Typography } from "@mui/material";
import CrudButtons from '../../../../GlobalFunction/CrudButtons'
import { useReactToPrint } from "react-to-print";
import ReportTable from "../../../../atoms/ReportFolder/ReportTable";

const columns = [
  { id: 'RowNum', label: 'Sr.No.', minWidth: 10 },
  { id: 'HkTypeName', label: 'HkTypeName', minWidth: 100 },
  { id: 'Abrv', label: 'Abrv', minWidth: 100 },
  { id: 'Remark', label: 'Remark', minWidth: 100 },
  { id: 'Status', label: 'Status', minWidth: 20 },
];
const HkType = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    HkTypeName: "",
    Abrv: "",
    Remark: "",
    Status: "1",
  });

  const [error, setError] = useState({
    HkTypeName: false,
  });

  const [isFormDisabled, setIsFormDisabled] = useState(true);
  const [currentHkTypeId, setCurrentHkTypeId] = useState(null);
  const [mode, setMode] = useState("view");
  const [lastInsertedHkTypeId, setLastInsertedHkTypeId] = useState(null);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [UserId] = useState(sessionStorage.getItem("UserId"));
  const [Status, setStatus] = useState("1");
  const [DataForPrint, setDataForPrint] = useState({});
  const [rows, setRows] = useState([]);

  const contentRef = useRef(null);
  const handlePrint = useReactToPrint({ contentRef });

  const HkTypeNameRef = useRef(null);
  const AbrvRef = useRef(null);
  const RemarkRef = useRef(null);

  // const permissions = useModulePermissions("House Keeping Type Master");

  const handleChangeStatus = (event) => {
    const updatedStatus = event.target.checked ? "1" : "0";
    setStatus(updatedStatus);
    setFormData((prevData) => ({
      ...prevData,
      Status: updatedStatus
    }))
  };

  useEffect(() => {
    const getRow = async () => {
      try {
        const res = await axiosInstance.post('MstHkType/getAllMstHkTypeDashBoard',
          {
            start: 0,
            PageSize: 0,
            SearchText: ""
          });

        if (res.data && res.data.Data) {
          setRows(res.data.Data);
          setDataForPrint(res.data.Data);
        } else {
          console.error('No data found in response');
        }
      } catch (err) {
        console.error('Error fetching data:', err);
      }
    };

    getRow();
  }, []);
  useEffect(() => {
    if (location.state && location.state.HkTypeId) {
      setCurrentHkTypeId(location.state.HkTypeId);
      fetchHkTypeData(location.state.HkTypeId);
      setMode("view");
    } else {
      setMode("add");
      setIsFormDisabled(false);
    }
  }, [location]);

  const fetchHkTypeData = async (id, flag) => {
    try {
      const response = await axios.post(`MstHkType/RetriveMstHkType`, {
        HkTypeId: parseInt(id),
        Flag: flag,
      });
      const {
        data: { Status, Data, responseStatusCode },
      } = response;
      if (Status === 0 && responseStatusCode === 1 && Data) {
        const HkTypeData = Data[0];
        setFormData({
          HkTypeName: HkTypeData.HkTypeName,
          Abrv: HkTypeData.Abrv,
          Remark: HkTypeData.Remark,
          Status: HkTypeData.Status,
        });
        setStatus(Data[0].Status.toString());
        setIsFormDisabled(true);
        setCurrentHkTypeId(HkTypeData.HkTypeId);
      } else if (
        response.data.Status === 1 &&
        response.data.responseStatusCode === 2
      ) {
        console.error(response.data.Message, { autoClose: 1000 });
      }
    } catch (error) {
      console.error("Error fetching housekeepingtype data:", error);
    }
  };

  const handlePrevious = async () => {
    if (currentHkTypeId && currentHkTypeId > 1) {
      await fetchHkTypeData(currentHkTypeId, "P");
    }
  };

  const handleNext = async () => {
    if (currentHkTypeId) {
      await fetchHkTypeData(currentHkTypeId, "N");
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));

    if (name === "HkType") {
      setFormData((prevState) => ({
        ...prevState,
        state: "",
      }));
    }

    if (name === "HkType" && value !== "") {
      setTimeout(() => {
        AbrvRef.current.focus();
      }, 100000);
    }
  };

  const handleKeyPress = (event, nextRef) => {
    if (event.key === "Enter" && nextRef) {
      event.preventDefault();
      nextRef.current.focus();
    }
  };

  const handleSubmit = async () => {
    let hasError = false;

    if (!formData.HkTypeName) {
      toast.error("HkTypeName is required");
      setError((prev) => ({ ...prev, HkTypeName: true }));
      hasError = true;
    } else {
      setError((prev) => ({ ...prev, HkTypeName: false }));
    }

    if (hasError) {
      return;
    }

    try {
      const payload = {
        HkTypeName: formData.HkTypeName,
        Abrv: formData.Abrv,
        Remark: formData.Remark,
        status: formData.Status,
      };

      let response;
      if (mode === "edit") {
        payload.HkTypeId = currentHkTypeId;
        payload.UpdatedBy = parseInt(UserId, 10);
        await UnLock(currentHkTypeId, "MstHkType", "HkTypeId");
        response = await axios.patch(`MstHkType/UpdateMstHkType`, payload);
      } else {
        payload.CreatedBy = parseInt(UserId, 10);
        response = await axios.post(`MstHkType/InsertMstHkType`, payload);
      }

      if (
        response.data.Status === 0 &&
        response.data.responseStatusCode === 1
      ) {
        toast.success(response.data.Message, { autoClose: 1000 });
        if (mode === "add") {
          setLastInsertedHkTypeId(response.data.Data);
          console.log(response.data.Data);
          await fetchHkTypeData(response.data.Data);

          setMode("view");
          setIsFormDisabled(true);
          setCurrentHkTypeId(response.data.Data);
        } else {
          setMode("view");
        }
        setIsFormDisabled(true);
      }
    } catch (error) {
      console.error("Error saving/updating housekeepingtype:", error);
    }
  };

  const handleEdit = async () => {
    // let Flag = await checkAndLock(currentHkTypeId, "MstHkType", "HkTypeId");
    // switch (Flag) {
    //   case 0:
    setMode("edit");
    setIsFormDisabled(false);
    //     break;
    //   case 1:
    //     toast.info("Record Already Locked", { autoClose: 500 });
    //     break;
    //   case 2:
    //     toast.info("Record Faled To Locked", { autoClose: 500 });
    //     break;
    //   default:
    //     toast.info("something Went Wrong", { autoClose: 500 });
    // }
  };

  const handleAdd = () => {
    setMode("add");
    setIsFormDisabled(false);
    setFormData({
      HkTypeName: "",
      Abrv: "",
      Remark: "",
      Status: "1",
    });
    setCurrentHkTypeId(null);

    setTimeout(() => {
      HkTypeNameRef.current.focus();
    }, 0);
  };

  const handleCancel = async () => {
    if (mode === "add") {
      await fetchHkTypeData(1, "L");
    } else {
      // await UnLock(currentHkTypeId, "MstHkType", "HkTypeId");
      await fetchHkTypeData(currentHkTypeId, "R");
    }
    setMode("view");
    setIsFormDisabled(true);
  };

  const handleExit = () => {
    navigate("/hk-typetable");
  };

  const handleDelete = async () => {
    // let Flag = await checkAndLock(currentHkTypeId, "MstHkType", "HkTypeId");
    // switch (Flag) {
    //   case 0:
    setOpenConfirmDialog(true);
    //     break;
    //   case 1:
    //     toast.info("Record Already Locked", { autoClose: 500 });
    //     break;
    //   case 2:
    //     toast.info("Rocord Failed To Locked", { autoClose: 500 });
    //     break;
    //   default:
    //     toast.info("Something Went Wrong", { autoClose: 500 });
    // }
  };

  const handleCloseConfirmDialog = () => {
    setOpenConfirmDialog(false);
  };
  const handleConfirmDelete = async () => {
    setOpenConfirmDialog(false);
    try {
      const response = await axiosInstance.post(`MstHkType/RetriveMstHkType`, {
        HkTypeId: currentHkTypeId,
        Flag: "D",
      });
      if (response instanceof Error) {
        return toast.error("Error Could not delete HKType");
      }
      const {
        data: { Status, Message, Data },
      } = response;
      if (Status === 0) {
        toast.success(Message, { autoClose: 500 });
        await fetchHkTypeData(currentHkTypeId, "N");
      } else {
        if (Array.isArray(Data) && Data.length > 0) {
          const msg = formatDeleteErrorMessage(Data);
          toast.error(msg, { autoClose: 500 });
        } else {
          toast.error(Message, { autoClose: 500 });
        }
      }
      // await UnLock(currentHkTypeId, "MstHkType", "HkTypeId");
      setIsFormDisabled(true);
    } catch (error) {
      console.error("Error deleting housekeepingtype:", error);
    }
  };

  return (
    <>
      <Box className="form-container"
        sx={{
          width: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          maxWidth: { xs: "calc(100vw - 60px)", sm: "100%", md: "100%" },
          height: { xs: "91.5vh", sm: "93.5vh", md: "auto", lg: "92vh" },
          overflowX: "hidden",
          overflowY: { xs: "auto", sm: "hidden", md: "hidden" },
        }}>
        <ToastContainer
          position="top-center"
          autoClose={2000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick={false}
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="light"
          transition={Slide}
        />
        <Grid container spacing={2} sx={{
          width: { xs: "93%", sm: "80%", md: "80%" },
          height: { xs: "450px", sm: "380px", md: "auto" },
          margin: "auto",
          marginTop: { xs: "50px", sm: '50px', md: "auto" },
          marginBottom: { xs: "20px", sm: '50px', md: "auto" },
          borderRadius: "8px",
          padding: { xs: "0px 5px 5px 5px", sm: "0px 20px 20px 20px" },
          backgroundColor: "#fff",
        }}>
          <Grid
            item
            xs={12}
            className="form_title"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              marginTop: "20px",
              flexDirection: { xs: "column", sm: "row", md: "row" },
            }}
          >
            <Grid
              sx={{
                display: "flex",
                justifyContent: { xs: "center", sm: "flex-start" },
                marginBottom: { xs: "10px", sm: 0 },
              }}
            >
              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  marginRight: { xs: "5px", sm: "10px" },
                  display: "block",
                }}
                className="three-d-button-previous"
                onClick={handlePrevious}
                disabled={
                  mode !== "view" || !currentHkTypeId || currentHkTypeId === 1
                }
              >
                <KeyboardArrowLeftIcon />
              </Button>

              <Button
                variant="contained"
                size="small"
                sx={{
                  backgroundColor: "#635bff",
                  display: "block",
                }}
                className="three-d-button-next"
                onClick={handleNext}
                disabled={mode !== "view" || !currentHkTypeId}
              >
                <NavigateNextIcon />
              </Button>
            </Grid>
            <Typography
              variant="h5"
              sx={{
                margin: "Auto",
                textAlign: { xs: "center", sm: "center" },
                fontSize: { xs: "24px", sm: "18px", md: "24px" },
              }}
            >
              Work Type
            </Typography>
            <Grid sx={{ display: "flex", justifyContent: "end" }}>
              <CrudButtons
                moduleName="House Keeping Type Master"
                mode={mode}
                onAdd={handleAdd}
                onEdit={handleEdit}
                onDelete={handleDelete}
                onView={handlePrint}
                onExit={handleExit}
                onPrevious={handlePrevious}
                onNext={handleNext}
                readOnlyMode={mode === 'view'}
              />
            </Grid>
          </Grid>

          <Grid
            item
            xs={12}
            className="form_field"
            sx={{ marginInline: { xs: "10px", sm: "80px" } }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="HkTypeName"
                  name="HkTypeName"
                  label={
                    <span>
                      HkTypeName <span style={{ color: "red" }}>*</span>
                    </span>
                  }
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.HkTypeName}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  error={error.HkTypeName}
                  helperText={error.HkTypeName && ""}
                  inputRef={HkTypeNameRef}
                  //  onKeyDown={handleKeyPress}
                  onKeyDown={(event) => handleKeyPress(event, AbrvRef)}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="Abrv"
                  name="Abrv"
                  label="Abrv"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Abrv}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={AbrvRef}
                  // onKeyDown={handleKeyPress}
                  onKeyDown={(event) => handleKeyPress(event, RemarkRef)}
                />
              </Grid>
              <Grid item xs={12} md={6} lg={6}>
                <TextField
                  id="Remark"
                  name="Remark"
                  label="Remark"
                  variant="filled"
                  fullWidth
                  className="custom-textfield"
                  value={formData.Remark}
                  onChange={handleInputChange}
                  disabled={isFormDisabled}
                  inputRef={RemarkRef}
                />
              </Grid>
              <Grid item xs={12} md={2}>
                <FormGroup>
                  <FormControlLabel
                    control={
                      <Checkbox
                        disabled={mode === 'view'}
                        checked={Status == "1"}
                        onChange={handleChangeStatus}
                      />
                    }
                    label="Status"
                  />
                </FormGroup>
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12} className="form_button"
            sx={{ marginBottom: "10px !important", marginInline: "10px" }}
          >
            {mode === "view" && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #d4d4d4, #ffffff)",
                  }}
                  onClick={handleAdd}
                  disabled
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg, #a7c5e9, #ffffff)",
                  }}
                  onClick={handleEdit}
                  disabled
                >
                  Cancel
                </Button>
              </>
            )}
            {(mode === "edit" || mode === "add") && (
              <>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleSubmit}
                >
                  Submit
                </Button>
                <Button
                  variant="contained"
                  sx={{
                    mr: 1,
                    background: "linear-gradient(290deg,   #b9d0e9, #e9f2fa)",
                  }}
                  onClick={handleCancel}
                >
                  Cancel
                </Button>
              </>
            )}
          </Grid>
        </Grid>
      </Box>
      <div style={{ display: "none" }}>
        {rows.length > 0 && (
          <ReportTable
            columns={columns}
            rows={rows.map(row => ({
              ...row,
              Status: row.Status === "1" ? "Active" : row.Status === "0" ? "Inactive" : row.Status,
            }))}
            title="HK Type Master"
            contentRef={contentRef}
            customStyles={{ backgroundColor: "#f5f5f5" }}
          />
        )}
      </div>
      {/* Delete Confirmation Modal */}
      <Dialog
        open={openConfirmDialog}
        onClose={handleCloseConfirmDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Confirm Deletion"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you want to delete this record?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleConfirmDelete}
          >
            Yes
          </Button>
          <Button
            sx={{
              backgroundColor: "#635bff",
              color: "white",
              "&:hover": {
                backgroundColor: "#1565c0",
                color: "white",
              },
            }}
            onClick={handleCloseConfirmDialog}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default HkType;
